import React, { useEffect } from "react";
import "../css/quickShare.scss";
import { PixelWithEvent } from "./common/PixelWithEvent ";
import { sendMessage } from "../apis/SendMessageAPI";
import { BASE_URL } from "../constans/ApiEndpointConstants";
import LocalStorageUtil from "../utils/localStorageUtil";
import Cookies from "js-cookie";
import { getFullDonationUrl } from "../utils/urlUtils";

const QuickShareModal = ({ isOpen, onClose, campaignUrl, detailsData }) => {
  const share_id = detailsData?.id || "";

  //event_id，要去重，一天之内用一个，存cookie
  const getEventId = (eventType) => {
    // 根据事件类型使用不同的cookie名
    const cookieName = `fb_event_id_${eventType}`;

    let storedEventId = Cookies.get(cookieName);
    if (storedEventId) {
      return storedEventId;
    } else {
      // 使用 10 位随机数字作为 event_id
      const newEventId = Math.round(Math.random() * 10000000000).toString();
      Cookies.set(cookieName, newEventId, { expires: 1 }); // 存储1天
      return newEventId;
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // 分享文案：优先使用 detailsData.share_text（如果存在），否则回退到默认文案
  const defaultShareText =
    "こんにちは！現在支援を受け付けている重要なプロジェクトを共有させていただきます。少額の寄付でもプロジェクトを前進させる力になります。また、このメッセージをシェアしていただくだけでも大きな支援となります。温かいご支援をお願いいたします。";

  const invitationTextRaw = detailsData.share_text || defaultShareText;

  // 将常见的智能引号替换为普通引号，避免 URL 编码后显示异常
  const invitationText = invitationTextRaw
    .replace(/'/g, "'")
    .replace(/'/g, "'")
    .replace(/"/g, '"')
    .replace(/"/g, '"');
  // Ensure shared link always points to donationDetails path.
  const safeBase = campaignUrl
    ? campaignUrl.replace(/\/$/, "")
    : window.location.origin;
  const baseShareUrl = detailsData
    ? getFullDonationUrl(detailsData, safeBase)
    : campaignUrl
    ? safeBase
    : `${BASE_URL.replace(/\/$/, "")}/donationDetails/${detailsData?.id || ""}`;
  const campaignUrlWithAd = (() => {
    try {
      const url = new URL(baseShareUrl);
      url.searchParams.set("ad", "share");
      return url.toString();
    } catch (e) {
      return baseShareUrl.includes("?")
        ? `${baseShareUrl}&ad=share`
        : `${baseShareUrl}?ad=share`;
    }
  })();
  const encodedCampaignUrl = encodeURIComponent(campaignUrlWithAd);
  const encodedInvitation = encodeURIComponent(
    `${invitationText}\n${campaignUrlWithAd}`
  );

  const shareOptions = [
    {
      id: "facebook",
      name: "Facebook",
      mobileText: "シェア",
      icon: "/svg-jp/f1-1.svg",
      svg: (
        <svg
          viewBox="0 0 1024 1024"
          xmlns="http://www.w3.org/2000/svg"
          class="css-1ro5f1a"
        >
          <path
            d="M1024,512C1024,229.23,794.77,0,512,0S0,229.23,0,512c0,255.55,187.23,467.37,432,505.78V660H302V512H432V399.2C432,270.88,508.44,200,625.39,200c56,0,114.61,10,114.61,10V336H675.44c-63.6,0-83.44,39.47-83.44,80v96H734L711.3,660H592v357.78C836.77,979.37,1024,767.55,1024,512Z"
            fill="#ffffff"
          ></path>
          <path
            d="M711.3,660,734,512H592V416c0-40.49,19.84-80,83.44-80H740V210s-58.59-10-114.61-10C508.44,200,432,270.88,432,399.2V512H302V660H432v357.78a517.58,517.58,0,0,0,160,0V660Z"
            fill="none"
          ></path>
        </svg>
      ),
      color: "#1877F2",
      url: `https://www.facebook.com/dialog/share?app_id=407682420960&display=popup&href=${encodedCampaignUrl}`,
    },
    {
      id: "x",
      name: "X",
      mobileText: "ポスト",
      icon: "/svg-jp/f1-2.svg",
      svg: (
        <svg
          fill="none"
          height={11}
          viewBox="0 0 10 11"
          width={10}
          xmlns="http://www.w3.org/2000/svg"
          className="css-1qbc0zf"
        >
          <path
            d="M5.95136 4.32737L9.67408 0H8.79192L5.55948 3.75739L2.97773 0H0L3.9041 5.68184L0 10.2197H0.882217L4.29576 6.25182L7.02227 10.2197H10L5.95114 4.32737H5.95136ZM4.74304 5.7319L4.34748 5.16612L1.20009 0.66412H2.55512L5.0951 4.29737L5.49067 4.86316L8.79233 9.58583H7.4373L4.74304 5.73212V5.7319Z"
            fill="white"
          />
        </svg>
      ),
      color: "#000000",
      url: `https://twitter.com/intent/post?text=${encodedInvitation}&url=${encodedCampaignUrl}`,
    },
    {
      id: "line",
      name: "LINE",
      mobileText: "LINEで送る",
      icon: "/svg-jp/f1-3.svg",
      svg: (
        <svg
          fill="none"
          height={12}
          viewBox="0 0 32 32"
          width={12}
          xmlns="http://www.w3.org/2000/svg"
          className="css-10scxvy"
        >
          <path
            clipRule="evenodd"
            d="M32 13.5926C32 6.45707 24.8227 0.651894 15.9998 0.651894C7.17822 0.651894 0 6.45707 0 13.5926C0 19.9896 5.69215 25.3469 13.3811 26.36C13.9022 26.4719 14.6113 26.7024 14.7907 27.1463C14.9521 27.5495 14.8963 28.1811 14.8423 28.5882C14.8423 28.5882 14.6546 29.7135 14.6141 29.9532L14.6079 29.9887C14.5319 30.4204 14.3403 31.5099 15.9998 30.8128C17.7077 30.0956 25.2144 25.4053 28.5712 21.5545H28.5705C30.8894 19.0203 32 16.4484 32 13.5926ZM12.7491 10.1446H11.6268C11.4547 10.1446 11.3148 10.2837 11.3148 10.4545V17.403C11.3148 17.5742 11.4547 17.713 11.6268 17.713H12.7491C12.9211 17.713 13.0607 17.5742 13.0607 17.403V10.4545C13.0607 10.2837 12.9211 10.1446 12.7491 10.1446ZM19.3514 10.1446H20.4737C20.6461 10.1446 20.7853 10.2837 20.7853 10.4545V17.403C20.7853 17.5742 20.6461 17.713 20.4737 17.713H19.3514C19.3238 17.713 19.2971 17.709 19.2716 17.7023L19.2701 17.7019C19.2695 17.7018 19.2689 17.7016 19.2683 17.7015C19.2679 17.7014 19.2674 17.7014 19.267 17.7014C19.26 17.6992 19.2532 17.6971 19.2459 17.6943C19.2429 17.6935 19.2399 17.6923 19.2369 17.6911L19.2367 17.691C19.2312 17.6888 19.2266 17.6867 19.2213 17.6846C19.2164 17.6824 19.2112 17.68 19.2066 17.6772C19.2035 17.6757 19.2008 17.6745 19.1977 17.6726C19.1913 17.669 19.1848 17.665 19.1784 17.661C19.1775 17.6601 19.1762 17.6592 19.1753 17.6586C19.1456 17.6384 19.1183 17.613 19.0962 17.5818L15.8974 13.2761V17.403C15.8974 17.5742 15.7578 17.713 15.5855 17.713H14.4635C14.2914 17.713 14.1515 17.5742 14.1515 17.403V10.4545C14.1515 10.2837 14.2914 10.1446 14.4635 10.1446H15.5855C15.5874 10.1446 15.5892 10.1447 15.591 10.1449C15.5927 10.145 15.5945 10.1452 15.5965 10.1452C15.602 10.1455 15.6072 10.1455 15.6124 10.1461L15.6184 10.1467L15.6237 10.1473L15.629 10.1482C15.6333 10.1485 15.6379 10.1491 15.6422 10.1498L15.6523 10.152L15.66 10.1537C15.6622 10.1545 15.6644 10.155 15.6666 10.1555L15.6707 10.1568C15.6772 10.1583 15.6833 10.1605 15.6894 10.1626C15.6928 10.1638 15.6959 10.165 15.6996 10.1663C15.7057 10.1684 15.7115 10.1712 15.7173 10.1739C15.7192 10.1746 15.7209 10.1754 15.7226 10.1763L15.7272 10.1785C15.7327 10.1812 15.7382 10.1846 15.7437 10.188C15.7471 10.1895 15.7502 10.1913 15.7532 10.1935C15.7587 10.1968 15.764 10.2008 15.7695 10.2045L15.7717 10.2062L15.7739 10.2078C15.7752 10.2088 15.7763 10.2098 15.7775 10.2109L15.7837 10.2157C15.7873 10.2186 15.7907 10.2215 15.794 10.2247L15.7965 10.2268L15.7999 10.2299C15.8063 10.236 15.8124 10.2421 15.8186 10.2491L15.8207 10.2509C15.8293 10.261 15.8376 10.2714 15.8449 10.2824L19.0398 14.5827V10.4545C19.0398 10.2837 19.1793 10.1446 19.3514 10.1446ZM10.0436 15.973H6.99422V10.4548C6.99422 10.2833 6.85466 10.1443 6.68289 10.1443H5.56029C5.38822 10.1443 5.24866 10.2833 5.24866 10.4548V17.4021V17.4027C5.24866 17.4862 5.28209 17.5617 5.33577 17.6173L5.33734 17.6192C5.33812 17.6201 5.33899 17.621 5.34006 17.6219L5.34466 17.6262C5.40079 17.68 5.47625 17.713 5.55998 17.713H5.56029H10.0436C10.2157 17.713 10.3547 17.5736 10.3547 17.4021V16.2836C10.3547 16.1121 10.2157 15.973 10.0436 15.973ZM26.9824 11.5737C26.9824 11.7455 26.8435 11.8843 26.6714 11.8843H23.6223V13.0585H26.6714C26.8435 13.0585 26.9824 13.1979 26.9824 13.3694V14.4879C26.9824 14.6594 26.8435 14.7985 26.6714 14.7985H23.6223V15.973H26.6714C26.8435 15.973 26.9824 16.1124 26.9824 16.2836V17.4024C26.9824 17.5736 26.8435 17.713 26.6714 17.713H22.1881H22.1875C22.104 17.713 22.0283 17.6797 21.9724 17.6262C21.9717 17.6256 21.9709 17.6249 21.9701 17.6242C21.9692 17.6234 21.9685 17.6227 21.9678 17.6219C21.9663 17.6207 21.9648 17.6188 21.9636 17.6173C21.9099 17.5617 21.8764 17.4862 21.8764 17.4027V17.4024V10.4551V10.4548C21.8764 10.3717 21.9096 10.2965 21.9629 10.2409C21.9645 10.239 21.966 10.2372 21.9678 10.2354C21.9684 10.2346 21.9692 10.234 21.9699 10.2334C21.9705 10.2329 21.971 10.2325 21.9715 10.232C22.0277 10.1779 22.1034 10.1443 22.1875 10.1443H22.1881H26.6714C26.8435 10.1443 26.9824 10.2837 26.9824 10.4551V11.5737Z"
            fill="#ffffff"
            fillRule="evenodd"
          />
        </svg>
      ),
      color: "#00C300",
      url: `https://social-plugins.line.me/lineit/share?url=${encodedCampaignUrl}`,
    },
    {
      id: "note",
      name: "note",
      mobileText: "noteで書く",
      icon: "/svg-jp/f1-4.svg",
      svg: (
        <svg
          fill="none"
          height={20}
          viewBox="0 0 20 20"
          width={20}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.66211 5.76314C7.3331 5.76314 9.62154 5.67836 11.2645 5.72095C13.469 5.77734 14.2974 6.73759 14.3254 9.10959C14.3534 10.4508 14.3254 14.2913 14.3254 14.2913H11.9404C11.9404 10.9311 11.9546 10.3765 11.9404 9.31771C11.9124 8.38586 11.6463 7.94164 10.9303 7.85686C10.172 7.77207 8.0471 7.84266 8.0471 7.84266V14.2913H5.66211V5.76314Z"
            fill="#040000"
          />
        </svg>
      ),
      color: "#000000",
      url: `https://note.com/share?url=${encodedCampaignUrl}`,
    },
  ];

  const handleShareOptionClick = (option) => {
    if (!option.url) {
      return;
    }

    // 传递平台名称给 handleShareClick
    handleShareClick(option.name);

    if (typeof option.onClick === "function") {
      option.onClick();
      return;
    }

    if (option.sameTab) {
      window.location.href = option.url;
      return;
    }

    window.open(option.url, option.target || "_blank", "noopener,noreferrer");
  };

  // 处理分享操作
  const handleShareClick = (platform) => {
    // 构建包含平台信息的事件名称
    const eventName = `Click Share - ${platform}`;

    const event_id = getEventId(eventName);

    // 调用 PixelWithEvent，传递包含平台信息的事件名称和 eventParams
    PixelWithEvent(eventName, event_id);

    // 获取 ad 和 userid 并发送消息，包含平台信息
    const storedAd = LocalStorageUtil.getAd();
    const ad = storedAd ?? "donation";
    const userid = localStorage.getItem("userid");
    const message = `${BASE_URL} [Click Share - ${platform}]:id=${share_id}:ad=${ad}:userid=${userid}`;
    sendMessage(message);
  };

  return (
    <div className="social-icons">
      {shareOptions.map((option) => (
        <button
          key={option.id}
          className={`icon-btn  ${option.id}`}
          onClick={() => handleShareOptionClick(option)}
        >
          <div className={`icon-circle ${option.id}`}>
            {typeof option.icon === "string" ? (
              <img alt="" src={option.icon} />
            ) : (
              option.svg
            )}
          </div>
          <span className="pc-text">{option.name}</span>
        </button>
      ))}
    </div>
  );
};

export default QuickShareModal;
